export function isGoalCardId(cardId: string) {
  return atob(cardId).includes('GoalCard');
}
